import _ from "underscore";
import ExpandCollapseNodeRenderer from "../tree/ExpandCollapseNodeRenderer";
import messageResource from "../../messageResource";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";

export default function CustomerNodeRenderer(tree, selectorFilter, expandCollapseCallback, selectionHelper)
{
    ExpandCollapseNodeRenderer.call(this, tree, selectorFilter, expandCollapseCallback);
    this.selectionHelper = selectionHelper;
}

CustomerNodeRenderer.prototype = _.create(ExpandCollapseNodeRenderer.prototype);

CustomerNodeRenderer.prototype.getEmptyEntityTooltip = function()
{
    return messageResource.getMessage("projects_customers_selector.customer_is_empty.tooltip");
};

CustomerNodeRenderer.prototype.isNeedToPushDisabledClass = function(treeNode)
{
    return treeNode.getValue().archived;
};

CustomerNodeRenderer.prototype.generateLabel = function ( treeNode, labelEl )
{
    HierarchySelectorUtil.renderSimpleEntityName(this, treeNode, labelEl);
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/customerProjectSelector/CustomerNodeRenderer.js